"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateClaimInputSchema = exports.ListClaimInputSchema = exports.CreateClaimInputSchema = exports.ClaimSchema = exports.ClaimStatusSchema = exports.ClaimStatus = void 0;
const zod_1 = require("zod");
const Evidence_1 = require("./Evidence");
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["Draft"] = "draft";
    ClaimStatus["Reviewed"] = "reviewed";
})(ClaimStatus || (exports.ClaimStatus = ClaimStatus = {}));
exports.ClaimStatusSchema = zod_1.z.nativeEnum(ClaimStatus);
exports.ClaimSchema = zod_1.z.object({
    id: zod_1.z.string(),
    status: exports.ClaimStatusSchema,
    claim: zod_1.z.string(),
    evidence: Evidence_1.EvidenceSchema.array(),
    reasoning: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
});
exports.CreateClaimInputSchema = zod_1.z.object({
    claim: zod_1.z.string(),
});
exports.ListClaimInputSchema = zod_1.z.object({
    status: exports.ClaimStatusSchema.optional(),
    packageId: zod_1.z.string().optional(),
});
exports.UpdateClaimInputSchema = zod_1.z.object({
    status: exports.ClaimStatusSchema.optional(),
    claim: zod_1.z.string().optional(),
    evidence: Evidence_1.EvidenceSchema.array().optional(),
    reasoning: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
});
//# sourceMappingURL=Claim.js.map